import { Grid, Stack, Typography, type SxProps, type Theme } from "@mui/material";
import type { CellDrillDownInfoBase } from "../../../../../../../../api/types/svTypes.ts";
import type { DrillDownState } from "../../../../hooks/useDrillDown";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import DrillDownConditionsTree from "./conditions/DrillDownConditionsTree.tsx";

interface Props {
  state: DrillDownState;
  configuration: DrillDownPage;
  info: CellDrillDownInfoBase;
  containerSx?: SxProps<Theme>;
}

export default function ReadonlyConditions({ state, configuration, info, containerSx }: Props) {
  if (!configuration || !info?.conditions || info.conditions.length === 0) {
    return <></>;
  }

  return (
    <Stack sx={{ minHeight: 0, height: "100%", width: "100%", ...containerSx }}>
      <Typography variant="subtitle2">Conditions</Typography>
      <Grid container sx={{ pt: 2, width: "100%", minHeight: 0 }}>
        <DrillDownConditionsTree
          conditions={state.conditionTree}
          readonly
          canBeRemoved={false}
          onRemoveField={state.actions.removeCondition}
          onFieldChanged={state.actions.updateCondition}
        />
      </Grid>
    </Stack>
  );
}
